<template>
  <RouterLink :to="localeRoute(to)" :active-class="activeClass">
    <slot />
  </RouterLink>
</template>

<script setup>
defineProps({
  to: {
    type: [Object, String],
    required: true,
  },
  activeClass: {
    type: String,
    default: undefined,
  },
});

const localeRoute = useLocaleRoute();
</script>
